import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const SIEMENS_EMAIL_REGEX = /^[^\s@]+@siemens\.com$/i;

export function siemensEmailDomainValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    return SIEMENS_EMAIL_REGEX.test(String(value).trim()) ? null : { siemensEmailDomain: true };
  };
}